import { render, staticRenderFns } from "./CChemMaterial.vue?vue&type=template&id=db718ed2"
import script from "./CChemMaterial.vue?vue&type=script&lang=js"
export * from "./CChemMaterial.vue?vue&type=script&lang=js"
import style0 from "./CChemMaterial.vue?vue&type=style&index=0&id=db718ed2&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db718ed2')) {
      api.createRecord('db718ed2', component.options)
    } else {
      api.reload('db718ed2', component.options)
    }
    module.hot.accept("./CChemMaterial.vue?vue&type=template&id=db718ed2", function () {
      api.rerender('db718ed2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CChemMaterial.vue"
export default component.exports